import { device_type } from "../enums";
import { IViewCustomerDummy } from "../interfaces-and-types";

export const customersDataHelper: IViewCustomerDummy[] = [
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac3",
    full_name: "",
    email: "customer1@gmail.com",
    ip_address: "192.168.34.12",
    device_type: device_type.pc,
    is_blacklisted: false,
    phone_number: "080----------",
    created_at: "nighttime",
    is_delete_locked: false,
    is_shadow_deleted: false,
  },
  // {
  //   id: "a231-5648cc43-56123c43-237d0098-1ac3",
  //   full_name: "test customer name",
  //   email: "customer2@gmail.com",
  //   ip_address: "192.163.34.87",
  //   device_type: device_type.pc,
  //   is_blacklisted: false,
  // },
  // {
  //   id: "18dd-11111d43-56123c43-237d0098-1ac3",
  //   full_name: "tester customer",
  //   email: "customer3@gmail.com",
  //   ip_address: "124.263.26.122",
  //   device_type: device_type.mobile,
  //   is_blacklisted: false,
  // },
  // {
  //   id: "c423-11111d43-56123c43-00001234-1ac3",
  //   full_name: "tester customer",
  //   email: "customer3@gmail.com",
  //   ip_address: "124.263.26.122",
  //   device_type: device_type.mobile,
  //   is_blacklisted: false,
  // },
  // {
  //   id: "a32a-c3c4c5c6-56123c43-237d0098-1ac3",
  //   full_name: "tester customer",
  //   email: "customer3@gmail.com",
  //   ip_address: "124.263.26.122",
  //   device_type: device_type.mobile,
  //   is_blacklisted: false,
  // },
];
